/* eslint-disable @typescript-eslint/naming-convention */

const COMMON_ENVIRONMENTS = {
  MARKETING_WEBSITE_URL: 'https://www.qima.com',
  MARKETING_WEBSITE_APP_LINK: '/app-marketing',
  SAMPLING_LEVELS_URL: 'https://www.qima.com/aql-acceptable-quality-limit',
  REFERENCE_SAMPLES: 'https://www.qima.com/reference-samples',
  GOOGLE_MAP_URL: 'https://www.google.com/maps/search/{location}/@39.9375346,115.837023,1z',
  TABLEAU_URL: 'https://dashboardspp.qima.com/',
};

export const ENVIRONMENT = {
  dev: {
    production: false,
    SERVER_URL: '/api-dev',
    FILE_URL: 'qimalab-dev',
    ...COMMON_ENVIRONMENTS,
    INTERNAL_DOMAINS: ['localhost', 'devlabs.qima.com', 'devlabs.qima.cn'],
  },
  pp: {
    production: false,
    SERVER_URL: '/api-pp',
    FILE_URL: 'qimalab-pp',
    ...COMMON_ENVIRONMENTS,
    INTERNAL_DOMAINS: ['localhost', 'preprodlabs.qima.com', 'preprodlabs.qima.cn'],
  },
  staging: {
    production: false,
    SERVER_URL: '/api-staging',
    FILE_URL: 'qimalab-staging',
    ...COMMON_ENVIRONMENTS,
    INTERNAL_DOMAINS: ['localhost', 'staginglabs.qima.com', 'staginglabs.qima.cn'],
  },
  prod: {
    production: true,
    SERVER_URL: '/api-prod',
    FILE_URL: 'qimalab-prod',
    ...COMMON_ENVIRONMENTS,
    INTERNAL_DOMAINS: ['labs.qima.com', 'labs.qima.cn'],
  },
};
